/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { AttributeRule } from '../../forms/EventSubscriptionBuilderForm/EventSubscriptionBuilderForm.defs';

/**
 * The attribute filter rules which do not require a value to be provided.
 */
export const EVENT_ATTRIBUTE_FILTER_RULES_WITHOUT_VALUE = [
  AttributeRule.Exists,
  AttributeRule.NotExists,
  AttributeRule.IsNull,
  AttributeRule.IsEmpty,
];

/**
 * The attribute filter rules which require a value to be provided.
 */
export const EVENT_ATTRIBUTE_FILTER_RULES_WITH_VALUE = [
  AttributeRule.Equals,
  AttributeRule.NotEquals,
  AttributeRule.LessThan,
  AttributeRule.LessThanEquals,
  AttributeRule.GreaterThan,
  AttributeRule.GreaterThanEquals,
  AttributeRule.BeginsWith,
];
